$(document).ready(function () {
    var mainElement = $(".form-item-field-select-the-action-your-ini");
    if ($('input:radio').is(':checked')) {
        $('input:radio:checked').parent().find(".views-field-description__value").show();
    }
    mainElement.find("input:radio").click(function (e) {
        mainElement.find(".views-field-description__value").hide();
        var radioValue = $(e.target).val();
        if (radioValue) {
            $(e.target).parent().find(".views-field-description__value").show();
        }
    });
});